
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import HistorySign from '../../components/course/history-sign.vue'
import signLoges from '../../components/course/sign-loges.vue'
  @Component({
    name: 'TableSign',
    components: { HistorySign, signLoges }
  })
export default class TableSign extends Vue {
    @Prop() isNew: boolean
    @Prop() tableSignData: any
    @Prop() signHistoryList: any
    @Prop() dialogZskSign: boolean
    @Prop() materialList: any
    @Prop() getStudentLevelList: any
    @Prop() student_id: string
    @Prop() sign_title: string


    @Watch('dialogZskSign')
    dialog(newVal, oldVal) {
      if(newVal) {
        this.action = true
        this.getListNew()
      }
    }

    addCustomer: any = {
      sign_title: '',
      student_name: '',
      historyList : [],
      historyListArr: [],
      selectThemeList: [],
      historySelectlist: [],
      material_remark: '',
      materialSelect: [],
      selectStudentLevel: '',
      teacherRemark: '',
      studentRemark: ''
    } // 正式课签到
    p_hight: any = window.innerHeight - 80 + 'px'
    materialSelectList: string = ''
    signPostData: any= []
    studentLevelId: string = ''
    action: boolean = false
    logHeight: number = 0

    // 主题筛选 多选
    changeTheme(val) {
      this.addCustomer.historySelectlist = []
      if (val.length === 0) {
        return false
      }
      for (var i = 0; i < val.length; i++) {
        for (var j = 0; j < this.addCustomer.historyList.length; j++) {
          if (val[i] === this.addCustomer.historyList[j].subject_id) {
            this.addCustomer.historySelectlist.push(this.addCustomer.historyList[j])
          }
        }
      }
    }

    changeSelectMaterial(val) {
      this.addCustomer.materialSelect = val
    }

    // 监测进度百分比
    changeSchedule(list) {
      let data = list.values
      var count = 0
      var len = data.length
      for (var i = 0; i < data.length; i++) {
        if (data[i].status === 1) {
          count += 0
        } else if (data[i].status === 2) {
          count += 100 / len / 2
        } else if (data[i].status === 3) {
          count += 100 / len
        } else if (data[i].status === 4) {
          count += 100 / len
        }
      }
      list.percentage = count.toFixed(1); 
      for (var i = 0; i < this.signPostData.length; i++) {
        if (this.signPostData[i].subject_id === list.subject_id) {
          this.signPostData[i] = list
        }
      }
    }
    getHeight() {
      window.onresize = () => {
        this.p_hight = window.innerHeight - 80 + 'px'
      }
    }

    // 正式课签到主题删除
    deleteContentList(val) {
      for (var j = 0; j < this.addCustomer.historySelectlist.length; j++) {
        if (val === this.addCustomer.historySelectlist[j].subject_id) {
          this.addCustomer.historySelectlist.splice(j, 1)
        }
      }
      for (var j = 0; j < this.addCustomer.historyListArr.length; j++) {
        if (val === this.addCustomer.historyListArr[j]) {
          this.addCustomer.historyListArr.splice(j, 1)
        }
      }
    }
    changeStudentLevel(val) {
      this.studentLevelId = val
    }
    getListNew() {
      this.addCustomer.sign_title = this.tableSignData.history_sign_time
      this.addCustomer.student_name = this.tableSignData.student_info.student_name
      this.addCustomer.material_remark = this.tableSignData.student_info.material_remark
      this.addCustomer.selectStudentLevel = this.tableSignData.student_info.sign_student_level_id
      if(this.isNew) { // 新建
        this.signPostData = this.tableSignData.able
        this.addCustomer.historyList = this.tableSignData.able
        this.addCustomer.teacherRemark = ''
        this.addCustomer.studentRemark = ''
      } else {
        this.signPostData = this.tableSignData.list
        this.addCustomer.historyList = this.tableSignData.list
        this.addCustomer.teacherRemark = this.tableSignData.student_info.teacher_remark
        this.addCustomer.studentRemark = this.tableSignData.student_info.student_remark
      } 
      this.addCustomer.historySelectlist = []
      this.addCustomer.historyListArr = []
      for (var i = 0; i < this.addCustomer.historyList.length; i++) {
        if (this.addCustomer.historyList[i].percentage != '0') {
          this.addCustomer.historySelectlist.push(this.addCustomer.historyList[i])
          this.addCustomer.historyListArr.push(this.addCustomer.historyList[i].subject_id)
        }
      }

      if(this.tableSignData.student_info.material_id) {
        this.addCustomer.materialSelect =  (this.tableSignData.student_info.material_id).split(',')
      } else {
        this.addCustomer.materialSelect =  []
      }
      this.$nextTick(function () {
        this.logHeight = this.$refs.getheight['offsetHeight']
      })
    }
    handleZskSignClose() {
      this.$emit('close-table-sign', {type: false})
      this.action = false
    }
    handleZskSignTrue() {
      const material_id = this.addCustomer.materialSelect.join(',')
      let data = {
        'subject_essential_info': this.signPostData,
        'sign_type': 1,
        'sign_student_level_id': this.addCustomer.selectStudentLevel,
        'course_type': 1,
        'material_id': material_id,
        'student_remark': this.addCustomer.studentRemark,
        'teacher_remark': this.addCustomer.teacherRemark,
        'material_remark': this.addCustomer.material_remark
      }
      this.$emit('close-table-sign', {type: true, data: data, isNew: this.isNew})
      this.action = false
    }
    mounted() {
      this.getHeight()
    }
}
